// Path: ./src/app/pages/OverviewDealTab/Loadable.ts
/**
 *
 * Asynchronously loads the component for OverviewDealTab
 *
 */

import { lazyLoad } from "../../../utils/loadable";

export const OverviewDealTab = lazyLoad(
  () => import("./index"),
  (module) => module.default
);
